import React from "react";
import { Box, Typography } from "@material-ui/core";
import * as constants from "./constants";
import "./styles.scss";
import { Dayjs } from "dayjs";
import { SanitizedHtml } from "halifax";

export interface IRebookHeaderProps {
  isSelectingReturnFlightForRebook: boolean;
  departureDate: Dayjs | null;
}

export const RebookHeader = (props: IRebookHeaderProps) => {
  const { isSelectingReturnFlightForRebook, departureDate } = props;

  return (
    <Box className="rebook-header-root">
      <Box className="rebook-header-container">
        <SanitizedHtml
          as={Typography}
          variant="h2"
          className="title-copy"
          html={constants.REBOOK_HEADER_TITLE(
            isSelectingReturnFlightForRebook,
            departureDate
          )}
        />
        <Typography variant="subtitle2" className="subtitle-copy">
          {constants.REBOOK_HEADER_SUBTITLE}
        </Typography>
      </Box>
    </Box>
  );
};
